import { FetchMrtRequest, MrtTemplateRequest } from './types';

const getMrtRequestString = (requestParams: FetchMrtRequest) => {
  const params = new URLSearchParams();

  if (requestParams?.page) {
    params.set('page', requestParams.page.toString());
  }
  if (requestParams?.limit) {
    params.set('limit', requestParams.limit.toString());
  }
  return params.toString();
};

const baseUrl = (orgId: string) =>
  `/base/organizations/${orgId}/machine-readable-templates`;

export const FETCH_MACHINE_READABLE_TEMPLATES = (
  requestParams: FetchMrtRequest
) => {
  return `${baseUrl(requestParams.organizationId)}?${getMrtRequestString(
    requestParams
  )}`;
};

export const UPLOAD_MACHINE_READABLE_TEMPLATES = (
  requestParams: FetchMrtRequest
) => {
  return baseUrl(requestParams.organizationId);
};

export const DOWNLOAD_MACHINE_READABLE_TEMPLATE = (
  requestParams: MrtTemplateRequest
) => {
  return `${baseUrl(requestParams.organizationId)}/${
    requestParams.id
  }/templates/download`;
};

export const DOWNLOAD_MACHINE_READABLE_TEMPLATE_ERROR_FILE = (
  requestParams: MrtTemplateRequest
) => {
  return `${baseUrl(requestParams.organizationId)}/${
    requestParams.id
  }/error-reports/download`;
};
